<template>
  <div v-if="tip" class="flex flex-start my-2" data-testid="devtip-item"
    :data-tip-id="tip.tip_id || tip._id">
    <div
      class="devtip-checkbox-wrapper devtip-checkbox-clickable mr-3"
      @click="showFeedbackForm(tip.text)"
    >
      <Checkbox :modelValue="isDone" binary disabled size="medium"
          class="devtip-status-checkbox" :class="{ 'devtip-unread': isUnread }"/>
    </div>
    <div class="flex flex-col cursor-pointer" data-testid="devtip-open"
      v-on="showFeedback ? { click: () => showFeedbackForm(tip.text) } : {}">
      <p class="mb-0 flex items-center gap-2 flex-wrap">
        <b>{{ tip.title?.[getLocale] ?? '-' }}</b>
        <span v-if="isUnread" class="devtip-new-badge" data-testid="devtip-new-badge">
          {{ $t('DevTipItemComponent.newBadge') }}</span>
      </p>
      <div class="flex text-xs">
        <p class="text-[var(--color-orange)] mr-1"
          data-testid="devtip-dimension">{{ tip.dimension?.[getLocale] ?? '-' }}</p>
        <p class="text-[var(--color-disabled)]">
            {{ $t('DevTipItemComponent.recievedAt') }} {{ getDate }}</p>
      </div>
      <p v-if="showText" class="mt-1 text-md">
        <span v-html="tip.text?.[getLocale] ?? '-'"></span></p>
    </div>
    <FeedbackOverlayComponent v-if="showFeedbackDialog" :visible="showFeedbackDialog"
    @update:visible="showFeedbackDialog = $event"
     @confirmed="onFeedbackConfirmed" :data="notification"></FeedbackOverlayComponent>
  </div>
  <Divider/>
</template>

<script>
import { Checkbox, Divider } from 'primevue';
import FeedbackOverlayComponent from '../FrontendOverlays/FeedbackOverlayComponent.vue';

export default {
  name: 'DevTipItemComponent',
  components: { Checkbox, Divider, FeedbackOverlayComponent },
  props: {
    tip: {
      type: Object,
      default: null,
    },
    showText: {
      type: Boolean,
      default: false,
    },
    overlayId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      showFeedbackPopup: true,
      showFeedbackDialog: false,
      notification: {},
      markedViewed: false,
    };
  },
  computed: {
    isDone() {
      return Boolean(this.tip?.done);
    },
    getDate() {
      const date = new Date(this.tip.date);
      return `${(`0${date.getDate()}`).slice(-2)}.${(`0${date.getMonth() + 1}`).slice(-2)}.${date.getFullYear()}`;
    },
    getLocale() {
      return this.$i18n.locale;
    },
    showFeedback() {
      return this.showFeedbackPopup; // && !this.tip.feedbackGiven;
    },
    isUnread() {
      return Boolean((this.tip?.new ?? this.tip?.isNew) && !this.markedViewed);
    },
  },
  methods: {
    // Opening a tip clears its unread marker. Done separately from the feedback
    // dialog so a failing call never blocks the user from giving feedback.
    markAsViewed() {
      const tipId = this.tip?.tip_id || this.tip?._id;
      if (!tipId || !this.isUnread) return;
      this.markedViewed = true;
      this.$store.dispatch('devTips/markDevTipAsViewed', tipId)
        .then(() => this.$emit('viewed'))
        .catch(() => { this.markedViewed = false; });
    },
    showFeedbackForm(text = '') {
      try {
        this.markAsViewed();
        this.notification = {
          helpful: this.tip?.positive === true || this.tip?.positive === false
            ? this.tip.positive
            : undefined,
          text,
          tipId: this.tip?.tip_id,
          feedback_text: this.tip?.feedback_text,
          done: this.tip?.done,
        };
        this.showFeedbackDialog = true;
        if (this.overlayId) {
          // this.$store.commit('removeFrontendOverlay', this.overlayId);
        }
      } catch (error) {
        this.$toast.add({
          severity: 'error',
          summary: this.$t('DevTipItemComponent.errorCouldNotFeedback'),
          detail: '',
          life: 3000,
        });
      }
    },
    onFeedbackConfirmed() {
      // Reset the feedback dialog state after feedback is submitted
      this.showFeedbackDialog = false;
      // Emit event to parent to refresh the DevTip list
      this.$emit('feedback-submitted');
    },
  },
};
</script>

<style scoped>
/* When not done, clicking the checkbox opens feedback (same as clicking the tip) */
.devtip-checkbox-clickable {
  cursor: pointer;
}
.devtip-checkbox-clickable :deep(.p-checkbox) {
  pointer-events: none;
}

/* FA-05.06: unread tips carry a readable "New" label, not only a colour hint */
.devtip-new-badge {
  font-size: 10px;
  font-weight: 600;
  line-height: 1.4;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--color-orange);
  border: 1px solid var(--color-orange);
  border-radius: 4px;
  padding: 0 4px;
  white-space: nowrap;
}

/* Unread tips keep the orange outline next to the "New" badge */
.devtip-unread :deep(.p-checkbox-box) {
  border-color: var(--color-orange) !important;
}

/* White checkmark only (box keeps theme color), bold */
.devtip-status-checkbox :deep(.p-checkbox-icon) {
  color: white !important;
  font-weight: bold !important;
}
.devtip-status-checkbox :deep(.p-checkbox-icon path) {
  fill: white !important;
  stroke: white;
  stroke-width: 1.5px;
  stroke-linecap: round;
  stroke-linejoin: round;
  paint-order: stroke fill;
}
</style>
